import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';
import { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

const Wrapper = styled.span`
    display: block;
    text-align: center;
`;

const Bar = styled.span`
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background: ${colors.ALT_DARKEST_GRAY};
    border-radius: 4px;
    overflow: hidden;

    i {
        z-index: 1;
        ${ifProp(
            'isActive',
            css`
                color: ${props =>
                    props.progress > 40 ? colors.WHITE : colors.LIGHT_ORANGE};
            `,
            css`
                color: ${colors.WHITE};
            `,
        )};
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: ${prop('progress')}%;
        height: 100%;
        ${ifProp(
            'isActive',
            css`
                background: ${colors.GOLD_ORANGE};
            `,
            css`
                background: ${colors.GRAY};
            `,
        )};
    }
`;

const Total = styled.span`
    position: relative;
    flex: 1;
    z-index: 1;
    font-size: 12px;
    color: ${colors.LIGHTEST_GRAY};
    text-align: left;
`;

const Open = styled(Total)`
    text-align: right;
`;

const ProgressBar = ({ title, icon: Icon, stats, isActive }) => {
    const progressPercentage =
        stats.all > 0 ? Math.floor((stats.completed / stats.all) * 100) : 0;

    return (
        <Wrapper title={title}>
            <Bar isActive={isActive} progress={progressPercentage.toFixed(4)}>
                <Total>{`${stats.all} Aufgaben`}</Total>
                <Icon size="sm" />
                <Open>{`${stats.pending} offen`}</Open>
            </Bar>
        </Wrapper>
    );
};

ProgressBar.propTypes = {
    title: PropTypes.string.isRequired,
    stats: PropTypes.object.isRequired,
    isActive: PropTypes.bool.isRequired,
};

export default ProgressBar;
